<div class="new-metric-container">
  <div class="back-button-container">
    <oph-back-button (buttonClick)="onBack()"></oph-back-button>
  </div>

  <div class="metric-content oph-scroll-bar">
    <tracker-detail-metric [metricForm]="metricForm" [editing]="false" [trackerDetail]="true"></tracker-detail-metric>
  </div>

  <footer>
    <oph-button color="green" (buttonClick)="onSave()" [disabled]="!valid()" [loading]="loading()">Save</oph-button>
  </footer>
</div>
